import React from "react";
import PropTypes from "prop-types";

const StepContent = ({ active, children }) => {
  if (!active) {
    return null;
  }
  return <>{children}</>;
};

StepContent.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
};

export default StepContent;
